import { FC } from "react"
import styled from "styled-components"

import { ContentfulProduct } from "@lib/types"
import { ColorSwatch } from "@components/ui"

interface Props {
  selected: string
  products: ContentfulProduct[]
}

export const ColorSelector: FC<Props> = ({ selected, products }) => {
  return (
    <StyledColorSelector>
      <SelectedColor>
        Color: <span>{selected}</span>
      </SelectedColor>
      <Colors>
        {products.map(({ slug, color }) => {
          return (
            <ColorSwatch
              key={color.name}
              type="link"
              href={slug}
              color={color}
              isActive={selected === color.name}
            />
          )
        })}
      </Colors>
    </StyledColorSelector>
  )
}

const StyledColorSelector = styled.div`
  padding: 1.8rem 0;
  border-bottom: 1px solid ${({ theme }) => theme.color.greyLight};
`

const SelectedColor = styled.div`
  margin: 0 0 1.2rem;
  font-size: 1.2rem;
  line-height: 2.4rem;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: ${({ theme }) => theme.color.grey};

  span {
    font-weight: 700;
  }
`

const Colors = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, 3.6rem);
  grid-gap: 0.6rem;

  @media (min-width: ${({ theme }) => theme.breakpoint.lg}px) {
    grid-template-columns: repeat(auto-fill, 3.8rem);
    grid-gap: 0.8rem;
  }

  @media (min-width: ${({ theme }) => theme.breakpoint.lg}px) {
    grid-template-columns: repeat(10, 1fr);
  }
`
